import React from 'react';
import PropTypes from 'prop-types';
import { useIsL } from '../../hooks/useBreakPoint';
import CheckoutRightRailWrapper from '../CheckoutPage/CheckoutRightRailWrapper';

/**
 * MobileCheckoutRightRailWrapper component that renders CheckoutRightRailWrapper
 * only in responsive/mobile view (L breakpoint and below)
 */
function MobileCheckoutRightRailWrapper({ stepId }) {
  const isLBreakPoint = useIsL();

  // Only render CheckoutRightRailWrapper in responsive view
  if (!isLBreakPoint) {
    return null;
  }

  return (
    <div className="step-right-rail-mobile">
      <CheckoutRightRailWrapper stepId={stepId} showFooter={false} />
    </div>
  );
}

MobileCheckoutRightRailWrapper.propTypes = {
  stepId: PropTypes.string.isRequired,
};

export default MobileCheckoutRightRailWrapper;
